import { cn } from "@lib/utils/cn";
import type { Column } from "@tanstack/react-table";
import { ArrowDown, ArrowUp, ArrowUpDown } from "lucide-react";

interface DataTableColumnHeaderProps<TData, TValue> {
  column: Column<TData, TValue>;
  title: string;
  className?: string;
}

export function DataTableColumnHeader<TData, TValue>({
  column,
  title,
  className,
}: DataTableColumnHeaderProps<TData, TValue>) {
  if (!column.getCanSort()) {
    return <div className={cn(className)}>{title}</div>;
  }

  const isSorted = !!column.getIsSorted();

  const toggleSort = () => {
    if (column.getIsSorted() === "desc") {
      column.clearSorting();
    } else {
      column.toggleSorting(column.getIsSorted() === "asc");
    }
  };

  return (
    <div className={cn("flex items-center space-x-2", className)}>
      <button
        type="button"
        className="flex items-center gap-1.5 font-semibold text-xs uppercase tracking-wider"
        onClick={toggleSort}
      >
        {title}
        {column.getIsSorted() === "desc" ? (
          <ArrowDown className={cn("h-4 w-4", isSorted && "text-primary")} />
        ) : column.getIsSorted() === "asc" ? (
          <ArrowUp className={cn("h-4 w-4", isSorted && "text-primary")} />
        ) : (
          <ArrowUpDown className="h-3.5 w-3.5 text-base-content/40" />
        )}
        {isSorted && column.getSortIndex() > 0 && (
          <span className="sort-badge">{column.getSortIndex() + 1}</span>
        )}
      </button>
    </div>
  );
}
